<template>
  <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-0.00195312" width="13.2" height="14.4" rx="2" fill="#4C85E8" />
    <rect
      opacity="0.5"
      x="6.59766"
      y="6.59961"
      width="13.2"
      height="14.4"
      rx="2"
      fill="#4C85E8"
    />
  </svg>
</template>
